import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
const NavLink = (props) => (
    <RouterNavLink
        activeClassName={!props.disableActive ? 'bg-app-blue-light text-white' : ''}
        className={
            "flex items-center px-2 py-2 text-sm leading-5 font-medium focus:outline-none focus:text-white transition ease-in-out duration-150 text-white hover:bg-app-blue-light hover:bg-opacity-50 hover:text-white"
        }
        to={props.to}>
        {props.icon !== undefined && (
            <FontAwesomeIcon
                icon={props.icon}
                size="lg"
                fixedWidth={true}
                className="mr-2"
            />
        )}
        {props.label}
    </RouterNavLink>
);

export default NavLink;
